/**
 * Returns a preview of a text
 *  @param {string} text - The text we're going to truncate
 *  @return {String} - The truncated text
 */
export const truncateText = (text: string) => {
  if (!text) return '';

  if (text.length > 100) {
    for (let i = 100; i > 0; i--) {
      if (
        text.charAt(i) === ' ' &&
        (text.charAt(i - 1) !== ',' ||
          text.charAt(i - 1) !== '.' ||
          text.charAt(i - 1) !== ';')
      ) {
        return `${text.substring(0, i)}...`;
      }
    }

    return `${text.substring(0, 100)}...`;
  }

  return text;
};
